<template>
    <div class="home" :style="{ background: back }">
        <div class="item-home">
            <div class="home-slider">
                <VueSlickCarousel v-bind="setting" v-if="AllBanner.length > 0">
                    <div
                            class="sliderBox"
                            v-for="item in AllBanner"
                            :key="item.index"
                            @click="GotoSpecialtylife(item.content)">
                        <div class="image-Blog">
                            <img :src="item.banner_poster"/>
                        </div>
                    </div>
                </VueSlickCarousel>
            </div>
            <div class="content-home">
                <div class="text-content-home">
                    <span class="color-fav"> عاقلانه </span>
                    <span> انتخاب کن و </span>
                    <span class="color-love"> عاشقانه </span>
                    <span> زندگی کن </span>
                </div>
                <div class="category-learn">
                    <v-row v-if="AllData.length > 0">
                        <v-col
                                :cols="
                index == 0 ||
                index == 3 ||
                index == 4 ||
                index == 7 ||
                index == 8 ||
                index == 11 ||
                index == 12
                  ? 5
                  : 7
              "
                                :lg="
                index == 0 ||
                index == 3 ||
                index == 4 ||
                index == 7 ||
                index == 8 ||
                index == 11 ||
                index == 12
                  ? 5
                  : 7
              "
                                :md="
                index == 0 ||
                index == 3 ||
                index == 4 ||
                index == 7 ||
                index == 8 ||
                index == 11 ||
                index == 12
                  ? 5
                  : 7
              "
                                v-for="(item, index) in AllData"
                                :key="index">
                            <router-link :to="{ name: 'specialtylife', query: { id: item.content_id } }">
                                <div class="img-category-learn">
                                    <img :src="item.content_poster"/>
                                </div>
                            </router-link>
                        </v-col>
                    </v-row>
                </div>
                <router-link to="pageQuestion">
                    <div class="boxQuestion">
                        <img :src="infoTest.quiz_image" alt=""/>
                    </div>
                </router-link>
                <div class="social-home">
                    <div
                            class="img-social-home"
                            v-for="(item, index) in AllSocial"
                            :key="index"
                    >
                        <router-link to="" v-on:click.native="openSocial(item)">
                            <img :src="item.social_avatar" alt=""/>
                        </router-link>
                    </div>
                    <div class="text-social-home">
                        <span>{{ social_text }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VueSlickCarousel from "vue-slick-carousel";
    import "vue-slick-carousel/dist/vue-slick-carousel.css";
    import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
    import oracle from "@/oracle";

    export default {
        name: "home",
        components: {VueSlickCarousel},
        data: () => ({
            back: "",
            infoTest: "",
            social_text: "",
            AllSocial: [],
            AllBanner: [],
            AllData: [],
            setting: {
                arrows: false,
                dots: true,
                autoplay: true,
                centerMode: false,
                infinite: false,
            },
        }),
        methods: {
            openSocial(item){
                window.open(item.social_url, '_blank')
            },
            GotoSpecialtylife(cont) {
                if (cont == null && cont.content_id == null) {
                    return;
                }
                this.$router.push({
                    name: "specialtylife",
                    query: {id: cont.content_id},
                });
            },
            getList(response) {
                this.AllSocial = response.data;
            },
            getListContent(response) {
                this.AllData = response.data;
            },
            getListBanner(response) {
                this.AllBanner = response.data;
            },
            handshakeResult(response) {
                oracle.setData("intro", response.data);
                this.back = oracle.getData("intro").background_image;
                this.social_text = oracle.getData("intro").social_text;
            },
            getInfo(response) {
                this.infoTest = response.data;
            },
        },
        mounted() {
            // if(!oracle.isMobile()){
            //     this.$router.push("landing")
            // }
            oracle.axios(
                "setting/getInfo",
                {search_by: "com.mindandlove1.android"},
                this.handshakeResult
            );
            oracle.axios("social/getList", null, this.getList);
            oracle.axios(
                "content/getList",
                {
                    content_type: 2,
                    limit_by: 500,
                    offset_by: 0,
                    order_by: "priority",
                    sort_by: "asc",
                },
                this.getListContent
            );
            oracle.axios(
                "banner/getList",
                {
                    limit_by: 500,
                    offset_by: 0,
                    order_by: "priority",
                    sort_by: "asc",
                },
                this.getListBanner
            );
            this.$root.$emit("content_title", "پیوند عقل و عشق");
            oracle.axios(
                "setting/getInfo",
                {search_by: "com.mindandlove1.android"},
                this.getInfo
            );
        },
    };
</script>

<style>
    .slick-dots {
        bottom: 6px;
    }

    .slick-dots li {
        margin: 0;
    }

    .item-home {
        overflow: auto;
        height: calc(100% - 60px);
        max-width: 1200px;
        margin: 0 auto;
        margin-top: 60px;
    }

    .home {
        background-image: url("../../assets/image/background.jpg");
        position: relative;
        background-size: cover;
        padding: 0;
        height: 100%;
        overflow: hidden;
    }

    .sliderBox {
        display: flex;
    }

    .image-Blog {
        padding-top: 56.25%;
        position: relative;
        overflow: hidden;
        width: 100%;
    }

    .image-Blog img {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .color-fav {
        color: green;
    }

    .color-love {
        color: red;
    }

    .text-content-home {
        display: flex;
        justify-content: center;
        font-size: 15px;
        font-weight: bold;
        padding: 15px 0;
    }

    .img-category-learn {
        width: 100%;
        padding-top: 56.25%;
        position: relative;
        overflow: hidden;
    }

    .img-category-learn img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: absolute;
        top: 0;
        left: 0;
    }

    .category-learn {
        margin: 15px 25px;
    }

    .category-learn .col-7,
    .category-learn .col-5 {
        padding: 4px !important;
    }

    .category-learn a {
        display: flex;
        height: 100%;
    }

    .social-home {
        background: rgba(255, 255, 255, 0.5);
        display: flex;
        padding: 10px 0;
        margin: 10px 15px;
        align-items: center;
    }

    .img-social-home {
        width: 30px;
        height: 30px;
        border-radius: 50px;
        margin: 0 10px;
        overflow: hidden;
    }

    .img-social-home img {
        width: 100%;
        height: 100%;
    }

    .text-social-home {
        font-size: 14px;
    }

    .boxQuestion {
        width: 90%;
        margin: 0 auto;
    }

    .boxQuestion img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    @media only screen and (max-width: 320px) {
        .img-social-home {
            width: 20px;
            height: 20px;
        }

        .text-social-home {
            font-size: 12px;
        }

        .home {
            height: auto;
        }

        .text-content-home span {
            font-size: 12px;
        }
    }
</style>
